module.exports = __webpack_public_path__ + "img/room13.0fcd14c8.gif";